import { render, staticRenderFns } from "./SingleVacancy.vue?vue&type=template&id=5efee5e4&scoped=true&"
import script from "./SingleVacancy.vue?vue&type=script&lang=js&"
export * from "./SingleVacancy.vue?vue&type=script&lang=js&"
import style0 from "./SingleVacancy.vue?vue&type=style&index=0&id=5efee5e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efee5e4",
  null
  
)

export default component.exports